import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { ALL_MONTHS } from "consts";
import { checkDaysMatchMonthLength } from "../../helpers/checkDaysMatchMonthLength";
import { getCellState, unifyDaysUsage } from "./helpers";
import { DateWrapper, UsageDisplay } from "./components";

export const MonthCell = ({
  cell,
  monthYear,
  numberMonthValue,
  isMonthModalOpen,
  handleMonthSelectedOpen,
}: {
  cell: any,
  monthYear: number,
  numberMonthValue: number,
  isMonthModalOpen: boolean,
  handleMonthSelectedOpen: () => void,
}) => {
  const allMonths = ALL_MONTHS;
  const [isCurrentCellSelected, setIsCurrentCellSelected] = useState(false);
  const monthId = allMonths[numberMonthValue - 1];
  const { original } = cell.row;
  const { unit } = original;
  const { monthBillType, monthUsage, days } = original.months[monthId] || {
    monthUsage: null,
    monthBillType: "",
    days: [],
  };
  const unifiedDays = unifyDaysUsage(days);

  const hasNullUsage = unifiedDays.length > 0 && !checkDaysMatchMonthLength(unifiedDays.length, numberMonthValue, monthYear);

  const {
    accountNumber,
    meterNumber,
    startDate,
    endDate,
    estimate: hasEstimate,
  } = original.collector;

  const hasHistoricalData = !accountNumber && !meterNumber;

  const start = dayjs.utc(startDate);
  const end = dayjs.utc(endDate);
  const current = dayjs.utc(`${monthYear}-${numberMonthValue}-01`);

  const isBeforeStart = current.isBefore(start, "month");
  const isAfterEnd = current.isAfter(end, "month");

  const { color } = getCellState({
    monthBillType,
    monthUsage,
    hasNullUsage,
    isBeforeStart,
    isAfterEnd,
    isCurrentCellSelected,
    hasHistoricalData,
    hasEstimate,
  });

  const handleDateWrapperClick = () => {
    if (monthUsage !== null) {
      handleMonthSelectedOpen();
      setIsCurrentCellSelected(true);
    }
  };

  useEffect(() => {
    if (isCurrentCellSelected && !isMonthModalOpen) setIsCurrentCellSelected(false)
  }, [isMonthModalOpen]) // eslint-disable-line

  return (
    <DateWrapper
      color={color}
      onClick={handleDateWrapperClick}
    >
      <UsageDisplay usage={monthUsage} unit={unit} />
    </DateWrapper>
  );
};
